import StateComponents from '../../../components/state-component/StateComponents'
import { Box, Divider, Typography } from '@mui/material'
import React, { useCallback, useEffect, useState } from 'react'
import { icons } from '../../../assets/icons/icons'
import { formPollListType, FrontApi } from '../../../api/front-api/front.api'
import clsx from 'clsx'
import { PollVoteCard, PollVotePopularBox } from './element/element'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../../store/store'
import PaginationCustom from '../../../components/pagination/PaginationCustomTwo'
import { setLoading, unsetLoading } from '../../../store/loading/loading.slice'
import { alertError } from '../../../components/alert/swal'
import SnackBarCustom from '../../../components/snackbar/SnackbarCustomTwo'
import { useTranslation } from 'react-i18next'

type Props = {}

const PollVoteWebsite: React.FC<Props> = ({ }: Props) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const img_url = useSelector((state: RootState) => state.api.image_api);

    const [page, setPage] = useState<number>(1);
    const [pageLimit, _setPageLimit] = useState<number>(6);
    const [totalItems, setTotalItems] = useState<number>(0);
    const [id_poll_type, set_id_poll_type] = useState<number | null>(null);
    const [poll_type_data, set_poll_type_data] = useState<any[]>([]);
    const [most_popular_data, set_most_popular_data] = useState<any[]>([]);
    const [data, setData] = useState<any[]>([]);
    const [show_snack, set_show_snack] = useState<boolean>(false);

    const handleSubmitPollVote = async (id_form_poll: number, id_form_poll_choice: number, auth_required: boolean) => {
        dispatch(setLoading());
        await FrontApi.sendForm({ id_form_poll, id_form_poll_choice, auth_required }).then((res) => {
            if (res.status < 300) {
                handleGetFormPollList();
                set_show_snack(true);
                setTimeout(() => {
                    set_show_snack(false);
                }, 500)
            }
        }).catch((err) => {
            console.log(err);
            alertError(t("HOME_PAGE_VOTING_FAILED"), err?.response?.data?.message || "");
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }

    const handleGetFormPollList = useCallback(async () => {
        let query: formPollListType = {
            page: page,
            limit: pageLimit
        }
        if (id_poll_type) query.id_poll_type = id_poll_type
        dispatch(setLoading());
        await FrontApi.formPollList(query).then((res) => {
            if (res.status < 300) {
                const items = res.data?.data?.items || [];
                const totalItems = res.data?.data?.meta?.totalItems;
                setData(items);
                setTotalItems(totalItems)
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }, [page, pageLimit, id_poll_type])
    const handleGetPollTypeData = async () => {
        await FrontApi.pollTypeList().then((res) => {
            if (res.status < 300) {
                const response: any[] = res.data?.data || [];
                set_poll_type_data(response);
            }
        }).catch((err) => {
            console.log(err)
        })
    }
    const handleGetPollMostPopular = async () => {
        await FrontApi.formPollMostPopular(5).then((res) => {
            if (res.status < 300) {
                const response = res.data?.data || [];
                set_most_popular_data(response)
            }
        }).catch((err) => {
            console.log(err)
        })
    }

    useEffect(() => {
        handleGetFormPollList();
    }, [handleGetFormPollList])

    useEffect(() => {
        handleGetPollTypeData();
        handleGetPollMostPopular();
    }, [])


    return (
        <Box className="w-full py-10 m-auto sm:max-w-[1440px] px-4 md:max-w-[1920px] min-h-screen">
            <Box className="grid grid-cols-12 gap-8">
                <Box className="flex flex-col gap-4 col-span-12 xl:col-span-5">
                    <StateComponents
                        typeProps={[
                            {
                                seq: 1,
                                type: "TEXT_FIELD",
                                gridProps: {
                                    xs: 12
                                },
                                fieldProps: {
                                    startAdornment: <Box px={2}><icons.SearchNormal /></Box>,
                                    placeholder: t('ค้นหา'),
                                    onChange: () => { },
                                }
                            }
                        ]}
                    />
                    <Box data-aos="zoom-in-right" className="flex flex-col gap-4 shadow-md rounded-xl p-6">
                        <Box component={"section"}>
                            <Typography fontWeight={600} fontSize={24}>
                                {t("HOME_PAGE_CATEGORY")}
                            </Typography>
                            <Box onClick={() => set_id_poll_type(null)} className={clsx('cursor-pointer hover:text-[#bea57f]', {
                                'text-[#9E640E]': null === id_poll_type
                            })} >
                                <Typography variant='h6' className="py-5">
                                    {t("HOME_PAGE_ALL_CATEGORIES")}
                                </Typography>
                                <Divider />
                            </Box>
                            {poll_type_data?.map((list, i) => {
                                return (
                                    <Box onClick={() => set_id_poll_type(list?.id_poll_type)} className={clsx('cursor-pointer hover:text-[#bea57f]', {
                                        'text-[#9E640E]': list?.id_poll_type === id_poll_type
                                    })} key={list?.id_poll_type}>
                                        <Typography variant='h6' className="py-5">
                                            {list?.poll_type || "-"}
                                        </Typography>
                                        {i !== poll_type_data.length - 1 && (
                                            <Divider />
                                        )}
                                    </Box>
                                )
                            })}
                        </Box>
                    </Box>

                    <Box data-aos="zoom-in-right" className="flex flex-col gap-4 shadow-md rounded-xl p-6">
                        <Typography fontSize={{ xs: "20px", xl: "24px" }} fontWeight={700}>
                            {t("HOME_PAGE_TOP_5_POLLS_WITH_THE_MOST_VOTES")}
                        </Typography>

                        <PollVotePopularBox data={most_popular_data?.map((list) => {
                            return {
                                end_date: list?.form_poll_end,
                                group_name: list?.poll_type,
                                start_date: list?.form_poll_start,
                                title: list?.form_poll_name || "-",
                                total_vote: list?.count
                            }
                        })} />
                    </Box>
                </Box>
                <Box className="col-span-12 xl:col-span-7">
                    <PollVoteCard onChange={(id, id_choice, auth_required) => {
                        handleSubmitPollVote(id, id_choice, auth_required)
                        // console.log(id_form_poll_choice, 'id_form_poll_choice')
                    }}
                        setData={setData}
                        data={data?.map((list) => {
                            const url_img = `${img_url}/${list?.media_file_path}/${list?.media_file_name}`
                            return {
                                id_form_poll: list?.id_form_poll,
                                form_poll_choice: list?.form_poll_choice,
                                id_form_poll_choice: list?.id_form_poll_choice,
                                img_src: url_img,
                                end_date: list?.form_poll_end,
                                group_name: list?.poll_type,
                                start_date: list?.form_poll_start,
                                title: list?.form_poll_name || "-",
                                total_vote: list?.total_vote || 0,
                                auth_required: list?.auth_required ? true : false,
                                id_form_poll_choice_select: list?.id_form_poll_choice_select
                            }
                        })} />

                    {data?.length > 0 ? (
                        <PaginationCustom
                            page={page}
                            pageLimit={pageLimit}
                            setPage={(np) => setPage(np)}
                            totalItems={totalItems}
                        />
                    ) : (
                        <Typography>
                            {t("ไม่มีข้อมูล")}
                        </Typography>
                    )}
                </Box>
            </Box>

            <SnackBarCustom
                open={show_snack}
                text={t("โหวตเรียบร้อย")}
            />
        </Box>
    )
}

export default PollVoteWebsite